import React, { useRef } from 'react'

import { useOutsideAlert } from '../../../hooks'

import { Column } from '../../column'

import { DropdownItem, DropdownItemData } from '../dropdown-item'

import { ItemsListProps } from './items-list.types'
import { useStyle } from './items-list.styles'

export const ItemsList = ({
  className = '',
  open,
  active,
  data,
  width,
  height,
  position,
  isScrollable,
  onChange,
  onOpen
}: ItemsListProps) => {
  const itemsRef = useRef<HTMLDivElement>(null)
  const usualRef = isScrollable ? null : itemsRef

  const classes = useStyle({
    width,
    height
  })

  const handleOnChange = (value: DropdownItemData) => {
    const { onClick } = value
    const isSelected = active === value.id
    if (onChange && !isSelected) {
      onChange(value)
    }

    if (onClick) {
      onClick(value)
    }

    if (onOpen) {
      onOpen(false)()
    }
  }

  useOutsideAlert(itemsRef, open, onOpen(false))

  return (
    <Column
      className={`${className} ${classes.itemsContainer} ${classes[position]}`}
      justifyContent="flex-start"
      ref={usualRef}
    >
      {data.map((item) => {
        const activeItem = active === item.id
        return (
          <DropdownItem
            key={`dropdown_${item.id}`}
            item={item}
            isScrollable={isScrollable}
            disabled={activeItem}
            onClick={handleOnChange}
          />
        )
      })}
    </Column>
  )
}
